import * as ACTION from '../constants';

const INITIAL_STATE = {
  error: null,
  loading: false,
  list: [],
};

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case ACTION.PROPERTY_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case ACTION.PROPERTY_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        list: action.list || [],
        error: null,
      };
    case ACTION.PROPERTY_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    default:
      return state;
  }
}
